import { Component, OnDestroy, OnInit } from "@angular/core";
import { Subject, Subscription } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { User } from "src/app/core/interfaces/api/user.interface";
import { ModalWithAction } from "src/app/core/interfaces/ui/bootstrap-modal.interface";
import { PlayerService } from "src/app/core/services/api/player.service";
import { BootstrapModalService } from "src/app/core/services/ui/bootstrap-modal.service";
import { FilterService } from "src/app/core/services/ui/filter.service";
import { GlobalService } from "src/app/core/services/ui/global.service";
import { PLAYER_STATE } from "src/app/core/helpers/global/player.constant";

@Component({
  selector: "app-block-player",
  templateUrl: "./block-player.component.html",
})
export class BlockPlayerComponent implements OnInit, OnDestroy {
  private playerId: string | undefined;
  private unsubscribe$: Subject<boolean> = new Subject<boolean>();
  public userProfile!: User;
  public PLAYER_STATE = PLAYER_STATE;
  public targetState: number = PLAYER_STATE.LOCKED;
  public reason: string = '';
  private _subscriptions: Subscription[] = [];
  constructor(
    private _playerService: PlayerService,
    private _bsModalService: BootstrapModalService<ModalWithAction<any>>,
    private _filterService: FilterService<object>,
    private _profileService: GlobalService
  ) {}

  ngOnInit(): void {
    this._profileService.profile.subscribe((profile) => {
      this.userProfile = profile;
    });
    this.subscribeToModalData();
  }

  private subscribeToModalData(): void {
    this._bsModalService
      .getDataIssued()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe({
        next: ({ selectedRow, targetState }) => {
          this.playerId = selectedRow?._id;
          if (targetState !== undefined) {
            this.targetState = targetState;
          }
        },
        error: () => this.closeModal(),
      });
  }

  public get isBlocking(): boolean {
    return this.targetState === PLAYER_STATE.LOCKED;
  }

  public get isReasonValid(): boolean {
    return this.reason.trim().length > 0;
  }

  public blockPlayer(): void {
    if (!this.playerId || !this.isReasonValid) {
      return;
    }
    const newState = {
      playerId: [this.playerId],
      state: this.targetState.toString(),
      blockedById: this.userProfile._id,
      reason: this.reason.trim(),
    };
    this._playerService
      .setPlayerStatus(newState)
      .subscribe(() => this.afterSubmitForm());
  }

  public closeModal(): void {
    this._bsModalService.closeModal();
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next(true);
    this.unsubscribe$.complete();
  }

  private afterSubmitForm(): void {
    this._filterService.updateFilterData({});
    this.closeModal();
  }
}
